/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import {
  FormElementType,
  FormRecordData
} from '../../../../../../../../models/record/items/form-record.model';
import { Component, Input, OnInit } from '@angular/core';
import {
  faCheck,
  faCheckSquare,
  faCircle,
  faCircleDot,
  faImage,
  faListDropdown,
  faListRadio,
  faSquare,
  faSquarePen
} from '@fortawesome/pro-regular-svg-icons';
import {
  FormInputType,
  getLinkType,
  LinkType
} from '../../../../../../../../models/record/items/input-record.model';

@Component({
  selector: 'form-record',
  templateUrl: './form-record.component.html',
  styleUrls: ['./form-record.component.scss'],
  standalone: false
})
export class FormRecordComponent implements OnInit {
  @Input() record!: FormRecordData;
  faCheckSquare = faCheckSquare;
  faSquare = faSquare;
  faCircle = faCircle;
  faCircleDot = faCircleDot;
  faCheck = faCheck;
  faSquarePen = faSquarePen;
  faListRadio = faListRadio;
  faListDropdown = faListDropdown;
  faImage = faImage;

  linkType?: LinkType;

  FormElementType = FormElementType;
  constructor() {}

  ngOnInit(): void {}

  getLinkType(inputType: FormInputType): LinkType | undefined {
    return getLinkType(inputType);
  }
}
